import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Services' },
    { to: '/about', label: 'About' },
    { to: '/contact', label: 'Contact' },
  ];

  const isActive = (to: string) =>
    to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white border-b border-[#E8E8E8] transition-all duration-300">
      <div className="w-full px-6 lg:px-14 flex items-center justify-between h-[78px]">

        {/* Logo — sits directly on white, no container needed */}
        <Link to="/" className="flex items-center cursor-pointer flex-shrink-0">
          <img
            src="https://www.energycontractorservices.com/wp-content/uploads/2012/06/ecs100.jpg"
            alt="Energy Contractor Services"
            className="h-11 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`relative text-[11px] tracking-[0.28em] uppercase font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap pb-0.5 ${
                isActive(to) ? 'text-[#C9A030]' : 'text-[#3A3A3A] hover:text-[#1A1A1A]'
              }`}
            >
              {label}
              {isActive(to) && (
                <span className="absolute -bottom-0.5 left-0 w-full h-px bg-[#C9A030]" />
              )}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:4054081117"
            className="flex items-center gap-2 border border-[#D0D0D0] text-[#3A3A3A] px-5 py-2.5 text-[11px] font-medium tracking-[0.2em] uppercase whitespace-nowrap cursor-pointer transition-all duration-200 hover:border-[#C9A030] hover:text-[#C9A030]"
          >
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-phone-line text-xs" />
            </span>
            405-408-1117
          </a>
          <Link
            to="/contact"
            className="flex items-center gap-2 bg-[#C9A030] text-white px-5 py-2.5 text-[11px] font-bold tracking-[0.2em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-[#B8901F]"
          >
            Get Compliant
          </Link>
        </div>

        <button
          className="lg:hidden flex flex-col gap-[5px] p-2 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-5 h-px bg-[#1A1A1A] transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-[6px]' : ''}`} />
          <span className={`block w-5 h-px bg-[#1A1A1A] transition-all duration-300 ${menuOpen ? 'opacity-0 w-0' : ''}`} />
          <span className={`block w-5 h-px bg-[#1A1A1A] transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-[6px]' : ''}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-[#E8E8E8] px-6 py-7 flex flex-col gap-5">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`text-[11px] tracking-[0.28em] uppercase font-semibold cursor-pointer ${
                isActive(to) ? 'text-[#C9A030]' : 'text-[#3A3A3A]'
              }`}
            >
              {label}
            </Link>
          ))}
          <div className="flex flex-col gap-3 mt-2">
            <a
              href="tel:4054081117"
              className="flex items-center gap-2 border border-[#D0D0D0] text-[#3A3A3A] px-5 py-3 text-[11px] font-medium tracking-[0.2em] uppercase whitespace-nowrap w-fit cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-xs" />
              </span>
              405-408-1117
            </a>
            <Link
              to="/contact"
              className="flex items-center gap-2 bg-[#C9A030] text-white px-5 py-3 text-[11px] font-bold tracking-[0.2em] uppercase whitespace-nowrap w-fit cursor-pointer"
            >
              Get Compliant
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
